var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d2-footer"},[_c('p',{staticClass:"d2-footer-copyright"},[_vm._v("\n    © CopyRight 2020-2020,"),_c('a',{staticClass:"d2-footer-copyright-link",attrs:{"target":"black","href":"http://beian.miit.gov.cn/"}},[_vm._v("豫ICP备17015625号-4")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f91b8c8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/footer/footer.vue
// module id = null
// module chunks = 